<app-slide #slide [withArrows]="false" [margin]="23" [elementWidth]="372"
    [elementQty]="permanentState.length" *ngIf="permanentState.length !== 0">
    <div class="container-state-transaction" [ngClass]="{'center-stepper': permanentState.length === 4}">
        <div class="container-state-message" *ngFor="let item of permanentState" >
            <app-stepper-state-element [item]="item"></app-stepper-state-element>
        </div>
    </div>
</app-slide>
